/**
 * Judge.me revamp widget — Amazon-style DOM tweak
 * Moves the stars element (sibling of reviewer-info) into the title wrapper
 * so stars and title render inline on the same visual line.
 *
 * Safe to run multiple times: each review item is processed once (data flag).
 */
(function () {
  'use strict';

  function relocateStars(widget) {
    const items = widget.querySelectorAll('.jm-review-item__content');
    items.forEach((content) => {
      if (content.dataset.starsRelocated === 'true') return;

      // Stars block: the jm-cluster that is NOT the reviewer-info
      const starsCluster = content.querySelector(
        ':scope > .jm-cluster:not(.jm-reviewer-info)'
      );
      const titleWrapper = content.querySelector('.jm-review-content__title-wrapper');
      if (!starsCluster || !titleWrapper) return;

      // Move the stars to be the first child of the title-wrapper
      titleWrapper.insertBefore(starsCluster, titleWrapper.firstChild);
      starsCluster.setAttribute('data-stars-embed', 'true');
      content.dataset.starsRelocated = 'true';
    });
  }

  const attached = new WeakSet();

  function attach(widget) {
    if (attached.has(widget)) return;
    attached.add(widget);
    relocateStars(widget);
    const mo = new MutationObserver(() => relocateStars(widget));
    mo.observe(widget, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('.jdgm-widget-revamp').forEach(attach);
    // Watch for widgets that mount asynchronously (Judge.me renders after script load)
    const docObserver = new MutationObserver(() => {
      document.querySelectorAll('.jdgm-widget-revamp').forEach(attach);
    });
    docObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
